module.exports = __webpack_public_path__ + "static/media/helicopter.82c28aef.svg";